exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ebx-background-close{background:#000;bottom:0;content:\"\";left:0;opacity:.4;position:fixed;top:70px;width:100vw;z-index:900}", ""]);

// exports
